export const tokenKey = 'token'
export const roleKey = 'role'

export enum USER_ROLES {
  ADMIN = 'ADMIN',
  LEAD = 'LEAD',
}

export enum USER_STATUSES {
  REGISTERED = 'REGISTERED',
  MEMBER = 'MEMBER',
}

export enum REFUND_STATUSES {
  ELIGIBLE = 'ELIGIBLE',
  DUE = 'DUE',
  CONFIRMED = 'CONFIRMED',
}

export enum ACCESS_LEVELS {
  BASIC = 'BASIC',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
  BLACK = 'BLACK',
}
